import { defineMessages, useIntl } from 'react-intl'
import { Page } from '../../..'
import { SlideOnMount } from '../../../shared/Animations'
import { OverlayQuestionsFooter } from '../../../shared/Routing'
import { MORTGAGE_INSURANCE_TOPIC_KEY } from '../../../../constants/topicKeys'
import { QUESTIONS } from '../../../../constants/messages'
import { PmiInfoMessages } from './PmiInfoMessages'
import { Text, Heading } from '@homebot/shared-ui-swashbuckle'

export const MSG = defineMessages({
  heading: {
    id: 'PMI.panel.header',
    defaultMessage: 'How can you remove it faster?',
  },
  subHeading: {
    id: 'PMI.panel.subheader',
    defaultMessage: 'There are a few ways to accelerate this.',
  },
})

export const PmiLearnMorePanel = () => {
  const intl = useIntl()

  return (
    <Page>
      <Page.Body>
        <SlideOnMount>
          <Heading size='xs' as='h2' variant='eyebrow' color='text.body'>
            {intl.formatMessage(MSG.heading)}
          </Heading>
          <Heading
            as='h3'
            marginBottom='spacing-400'
            fontWeight='semibold'
            size='sm'
          >
            {intl.formatMessage(MSG.subHeading)}
          </Heading>
        </SlideOnMount>
        <SlideOnMount>
          <PmiInfoMessages />
        </SlideOnMount>
        <Page.Disclaimer />
      </Page.Body>
      <Page.Footer>
        <SlideOnMount>
          <OverlayQuestionsFooter
            topic={intl.formatMessage(QUESTIONS.mortgageInsuranceTopic)}
            questions={[QUESTIONS.mortgageInsuranceFooter]}
            topicKey={MORTGAGE_INSURANCE_TOPIC_KEY}
            placeholder
            disableCospo
          />
        </SlideOnMount>
      </Page.Footer>
    </Page>
  )
}
